import { DatePipe } from '@angular/common';
import AppValues from 'src/app/common/app.values';
import FieldsConstants from 'src/app/common/fields.constants';
import { AdditionalCustomValidation } from 'src/app/forms/fields/components/multiple-custom-names-form-field/multiple-custom-form-field.enum';
import FieldAllowedAttributeTypes from 'src/app/forms/fields/field-allowed-attribute-types.values';
import FieldAllowedValueClasses from 'src/app/forms/fields/field-allowed-value-classes.values';
import { ProfileFormTypes } from 'src/app/forms/forms.enum';
import { Attribute } from 'src/app/interfaces/form-and-field.interface';

export const phoneNumberMetadata: Attribute = {
  name: 'phone_number',
  value_class_front: FieldAllowedValueClasses.PHONE,
  min_length: 1,
  max_length: 15,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: false,
  read_only: true,
  label: 'FORM_CONSTRUCTOR_PROFILE_BASE_PHONE_NUMBER_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_BASE_PHONE_NUMBER_LABEL_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.PROFILE,
};

export const authenticatorBindingMetadata: Attribute = {
  name: 'has_bound_authenticator',
  value_class_front: FieldAllowedValueClasses.AUTHENTICATOR_BINDING,
  min_length: 1,
  max_length: 15,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: false,
  read_only: true,
  placeholder: '',
  security: false,
  scheme_name: ProfileFormTypes.PROFILE,
};

export const phoneNumberMetadataBase: Attribute = {
  name: 'phone_number',
  value_class_front: FieldAllowedValueClasses.PHONE,
  min_length: 1,
  max_length: 15,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: true,
  read_only: true,
  label: 'FORM_CONSTRUCTOR_PROFILE_BASE_PHONE_NUMBER_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_BASE_PHONE_NUMBER_LABEL_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.BASE,
};

export const profileImageMetadata: Attribute = {
  name: 'image_url',
  value_class_front: FieldAllowedValueClasses.PHOTO,
  max_length: 1000,
  min_length: 1,
  type_attribute: FieldAllowedAttributeTypes.FILE,
  required: false,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_BASE_PHOTO_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_BASE_PHOTO_LABEL_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.PROFILE,
};

export const aliasMetadata: Attribute = {
  name: 'alias',
  value_class_front: FieldAllowedValueClasses.ALIAS,
  min_length: FieldsConstants.MIN_ALIAS_LEN,
  max_length: FieldsConstants.MAX_ALIAS_LEN,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_ALIAS_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_INDIVISUAL_ALIAS_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.PROFILE,
};

export const organizationNameMetadata: Attribute = {
  name: 'organization_name',
  value_class_front: FieldAllowedValueClasses.ORGANIZATION_NAME,
  min_length: FieldsConstants.MIN_ORGANIZATION_NAME_LEN,
  max_length: FieldsConstants.MAX_ORGANIZATION_NAME_LEN,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_ORGANIZATION_NAME_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_ORGANIZATION_NAME_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.PROFILE,
};

export const verifiedEmailMetadata: Attribute = {
  name: 'verified_email',
  value_class_front: FieldAllowedValueClasses.EMAIL,
  min_length: FieldsConstants.MIN_EMAIL_LEN,
  max_length: FieldsConstants.MAX_EMAIL_LEN,
  type_attribute: FieldAllowedAttributeTypes.EMAIL,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_BASE_EMAIL_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_BASE_EMAIL_LABEL_PLACEHOLDER',
  security: false,
  scheme_name: 'account',
};

export const emailVerifiedWarningMetadata: Attribute = {
  name: 'email',
  value_class_front: FieldAllowedValueClasses.WARNING_LABLE,
  min_length: FieldsConstants.MIN_EMAIL_LEN,
  max_length: FieldsConstants.MAX_EMAIL_LEN,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: true,
  read_only: true,
  label: 'FORM_CONSTRUCTOR_PROFILE_WARNING_LABLE',
  placeholder: '',
  security: false,
  scheme_name: 'account',
};

export const baseFieldsMetadata: Attribute[] = [
  profileImageMetadata,
  verifiedEmailMetadata,
  aliasMetadata,
  organizationNameMetadata,
  phoneNumberMetadata,
  authenticatorBindingMetadata,
];

export const baseFieldsWithWarningMetadata: Attribute[] = [
  profileImageMetadata,
  verifiedEmailMetadata,
  emailVerifiedWarningMetadata,
  aliasMetadata,
  organizationNameMetadata,
  phoneNumberMetadata,
  authenticatorBindingMetadata,
];

export const zipCodeMetadata: Attribute = {
  name: 'zip_code',
  value_class_front: FieldAllowedValueClasses.ZIP_CODE,
  min_length: FieldsConstants.MIN_ZIP_CODE_LEN,
  max_length: FieldsConstants.MAX_ZIP_CODE_LEN,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_ADDITIONAL_ZIP_CODE_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_ADDITIONAL_ZIP_CODE_LABEL_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.PROFILE,
};

export const profileLocationMetadata: Attribute = {
  name: 'location',
  value_class_front: FieldAllowedValueClasses.LOCATION,
  min_length: 1,
  max_length: 50,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_ADDITIONAL_LOCATION_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_ADDITIONAL_LOCATION_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.PROFILE,
};

export const profileViewLocationMetadata: Attribute = {
  ...profileLocationMetadata,
  label: 'PROFILE_ADDITIONAL_LOCATION_LABEL',
};

export const fullAddressLocationMetadata: Attribute = {
  ...profileLocationMetadata,
  label: 'PROFILE_ADDITIONAL_LOCATION_LABEL',
  value_class_front: FieldAllowedValueClasses.FULL_ADDRESS_LOCATION,
};

export const profileViewportFieldMetadata: Attribute = {
  name: 'viewport',
  value_class_front: FieldAllowedValueClasses.VIEWPORT,
  min_length: 1,
  max_length: 50,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: false,
  read_only: true,
  label: 'Viewport',
  placeholder: 'Automatically by viewport',
  security: false,
  scheme_name: ProfileFormTypes.PROFILE,
};

export const profileAboutMetadata: Attribute = {
  name: 'about',
  value_class_front: FieldAllowedValueClasses.TEXTAREA,
  min_length: 1,
  max_length: 1000,
  type_attribute: FieldAllowedAttributeTypes.TEXT,
  required: false,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_ADDITIONAL_ABOUT_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_ADDITIONAL_ABOUT_LABEL_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.PROFILE,
};

export const additionalProfileAttributes: Attribute[] = [profileViewportFieldMetadata, profileAboutMetadata];

export const additionalProfileFieldsMetadata: Attribute[] = [profileLocationMetadata, ...additionalProfileAttributes];

export const additionalProfileViewMetadata: Attribute[] = [profileViewLocationMetadata, ...additionalProfileAttributes];

export const additionalProfileFieldsWithFullAddressLocationMetadata: Attribute[] = [
  fullAddressLocationMetadata,
  ...additionalProfileAttributes,
];

export const alternativeNameMetadata: () => Attribute = () => ({
  name: 'alternative_names',
  value_class_front: FieldAllowedValueClasses.ALTERNATIVE_NAME,
  min_length: 1,
  max_length: 100,
  type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
  required: false,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_ALTERNATIVE_NAMES_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_ALTERNATIVE_NAMES_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.ORGANIZATION,
  additional_validation: AdditionalCustomValidation.ORGANIZATION_NAME,
});

export const organizationTypeMetadata: Attribute = {
  name: 'organization_type',
  value_class_front: FieldAllowedValueClasses.ORGANIZATIONS_TYPE_INPUT_SELECT,
  min_length: 1,
  max_length: 50,
  type_attribute: FieldAllowedAttributeTypes.INPUT_SELECT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_ORGANIZATION_TYPE_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_ORGANIZATION_TYPE_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.ORGANIZATION,
};

export const organizationRoleFieldsMetadata: Attribute[] = [
  {
    name: 'specialty',
    value_class_front: FieldAllowedValueClasses.SPECIALTIES_SELECT,
    min_length: 1,
    max_length: 2000,
    type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_SPECIALTIES_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_SPECIALTIES_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.ORGANIZATION,
  },
  {
    name: 'diseases',
    value_class_front: FieldAllowedValueClasses.DISEASES_SELECT,
    min_length: 1,
    max_length: 2000,
    type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_DISEASES_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_DISEASES_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.ORGANIZATION,
  },
  organizationTypeMetadata,
  alternativeNameMetadata(),
  {
    name: 'website',
    value_class_front: FieldAllowedValueClasses.URL,
    min_length: FieldsConstants.MIN_WEBSITE_LINK_LENGTH,
    max_length: FieldsConstants.MAX_WEBSITE_LINK_LENGTH,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: false,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_WEBSITE_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_WEBSITE_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.ORGANIZATION,
  },
];

export const languageFieldAttr: Attribute = {
  name: 'language',
  value_class_front: FieldAllowedValueClasses.LANGUAGES_SELECT,
  min_length: 1,
  max_length: 1300,
  type_attribute: FieldAllowedAttributeTypes.MULTIPLE_SEARCH_SELECT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_LANGUAGE_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_LANGUAGE_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.INDIVIDUAL,
};

export const genderMetadata: Attribute = {
  name: 'gender',
  value_class_front: FieldAllowedValueClasses.GENDER_SELECT,
  min_length: 1,
  max_length: 100,
  type_attribute: FieldAllowedAttributeTypes.SELECT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_GENDER_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_GENDER_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.INDIVIDUAL,
};

export const individualUserFieldsMetadata: Attribute[] = [
  {
    name: 'first_name',
    value_class_front: FieldAllowedValueClasses.ALPHABETIC_NAME,
    min_length: 1,
    max_length: 50,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_FIRST_NAME_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_FIRST_NAME_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.INDIVIDUAL,
  },
  {
    name: 'middle_name',
    value_class_front: FieldAllowedValueClasses.ALPHABETIC_NAME,
    min_length: 1,
    max_length: 100,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: false,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_MIDDLE_NAME_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_MIDDLE_NAME_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.INDIVIDUAL,
  },
  {
    name: 'last_name',
    value_class_front: FieldAllowedValueClasses.ALPHABETIC_NAME,
    min_length: 1,
    max_length: 50,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_LAST_NAME_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_LAST_NAME_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.INDIVIDUAL,
  },
  {
    name: 'suffix',
    value_class_front: FieldAllowedValueClasses.SUFFIX_SELECT,
    min_length: 3,
    max_length: 4,
    type_attribute: FieldAllowedAttributeTypes.SELECT,
    required: false,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_SUFFIX_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_SUFFIX_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.INDIVIDUAL,
  },
  genderMetadata,
  {
    name: 'date_of_birth',
    value_class_front: FieldAllowedValueClasses.DATE,
    min_length: 1,
    max_length: 50,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_DATE_OF_BIRTH_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_INDIVIDUAL_DATE_OF_BIRTH_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.INDIVIDUAL,
    visual_format: (value: string) => {
      return new DatePipe('en-US').transform(value, AppValues.DATE_FORMAT_SHORT);
    },
  },
  languageFieldAttr,
];

export const patientDiseasesAttrMetadata: Attribute = {
  name: 'diseases',
  value_class_front: FieldAllowedValueClasses.DISEASES_SELECT,
  min_length: 1,
  max_length: 2000,
  type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
  required: false,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_DISEASES_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_DISEASES_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.PATIENT,
};

export const patientRoleFieldsMetadata: Attribute[] = [
  {
    name: 'patient_id',
    value_class_front: FieldAllowedValueClasses.ALPHANUMERIC,
    min_length: 10,
    max_length: 10,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: true,
    label: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_PATIENT_ID_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_PATIENT_ID_PLACEHOLDER',
    security: true,
    scheme_name: ProfileFormTypes.PATIENT,
  },
  {
    name: 'insured',
    value_class_front: FieldAllowedValueClasses.YES_NO_SELECT,
    min_length: 1,
    max_length: 5,
    type_attribute: FieldAllowedAttributeTypes.SELECT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_INSURED_LABEL',
    view_label: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_INSURED_VIEW_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_INSURED_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.PATIENT,
  },
  {
    name: 'insurance_carrier_text',
    value_class_front: FieldAllowedValueClasses.CHARACTERS,
    min_length: 1,
    max_length: 100,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_INSURANCE_CARRIER_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_INSURANCE_CARRIER_PLACEHOLDER',
    security: false,
    enabled_if: { name: 'insured', value: 'YES' },
    scheme_name: ProfileFormTypes.PATIENT,
  },
  {
    name: 'place_of_birth',
    value_class_front: FieldAllowedValueClasses.TEXT_LOCATION,
    min_length: 1,
    max_length: 150,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_PLACE_OF_BIRTH_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_PATIENT_PLACE_OF_BIRTH_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.PATIENT,
  },
  patientDiseasesAttrMetadata,
];

export const medStaffSpecialtyFieldAttrMetadata: Attribute = {
  name: 'specialty',
  value_class_front: FieldAllowedValueClasses.SPECIALTIES_SELECT,
  min_length: 1,
  max_length: 2000,
  type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_MED_STAFF_SPECIALTIES_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_MED_STAFF_SPECIALTIES_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.MED_STAFF,
};
export const medstaffOrganizationLinkAttrMetadata: Attribute = {
  name: 'organization_which_represented',
  value_class_front: FieldAllowedValueClasses.LINKED_ORGANIZATION_IDS_SELECT,
  min_length: 1,
  max_length: 100,
  type_attribute: FieldAllowedAttributeTypes.MULTIPLE_SUGGESTIONS_SEARCH_SELECT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_MED_STAFF_ORGANIZATION_WHICH_REPRESENTED_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_MED_STAFF_ORGANIZATION_WHICH_REPRESENTED_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.MED_STAFF,
};

export const medStaffRoleFieldsMetadata: Attribute[] = [
  medStaffSpecialtyFieldAttrMetadata,
  {
    name: 'education',
    value_class_front: FieldAllowedValueClasses.TEXTAREA,
    min_length: 1,
    max_length: 300,
    type_attribute: FieldAllowedAttributeTypes.TEXTAREA,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_MED_STAFF_EDUCATION_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_MED_STAFF_EDUCATION_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.MED_STAFF,
  },
  {
    name: 'fellowship',
    value_class_front: FieldAllowedValueClasses.TEXTAREA,
    min_length: 1,
    max_length: 300,
    type_attribute: FieldAllowedAttributeTypes.TEXTAREA,
    required: false,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_MED_STAFF_FELLOWSHIP_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_MED_STAFF_FELLOWSHIP_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.MED_STAFF,
  },
  {
    name: 'treatment_of_diseases',
    value_class_front: FieldAllowedValueClasses.DISEASES_SELECT,
    min_length: 1,
    max_length: 2000,
    type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
    required: false,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_MED_STAFF_DISEASES_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_MED_STAFF_DISEASES_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.MED_STAFF,
  },
  medstaffOrganizationLinkAttrMetadata,
];

export const doctorSpecialtyAttrMetadata: Attribute = {
  name: 'specialty',
  value_class_front: FieldAllowedValueClasses.SPECIALTIES_SELECT,
  min_length: 1,
  max_length: 2000,
  type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_SPECIALTIES_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_SPECIALTIES_PLACEHOLDER',
  security: false,
  scheme_name: ProfileFormTypes.DOCTOR,
};

export const doctorRoleFieldsMetadata: Attribute[] = [
  doctorSpecialtyAttrMetadata,
  {
    name: 'education',
    value_class_front: FieldAllowedValueClasses.TEXTAREA,
    min_length: 1,
    max_length: 300,
    type_attribute: FieldAllowedAttributeTypes.TEXTAREA,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_EDUCATION_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_EDUCATION_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.DOCTOR,
  },
  {
    name: 'fellowship',
    value_class_front: FieldAllowedValueClasses.TEXTAREA,
    min_length: 1,
    max_length: 300,
    type_attribute: FieldAllowedAttributeTypes.TEXTAREA,
    required: false,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_FELLOWSHIP_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_FELLOWSHIP_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.DOCTOR,
  },
  {
    name: 'treatment_of_diseases',
    value_class_front: FieldAllowedValueClasses.DISEASES_SELECT,
    min_length: 1,
    max_length: 2000,
    type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_DISEASES_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_DISEASES_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.DOCTOR,
  },
  {
    name: 'organization_which_represented',
    value_class_front: FieldAllowedValueClasses.LINKED_ORGANIZATION_IDS_SELECT,
    min_length: 1,
    max_length: 100,
    type_attribute: FieldAllowedAttributeTypes.MULTIPLE_SUGGESTIONS_SEARCH_SELECT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_ORGANIZATION_WHICH_REPRESENTED_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_ORGANIZATION_WHICH_REPRESENTED_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.DOCTOR,
  },
];

export const researcherRoleFieldsMetadata: Attribute[] = [
  {
    name: 'organization_which_represented',
    value_class_front: FieldAllowedValueClasses.LINKED_ORGANIZATION_IDS_SELECT,
    min_length: 1,
    max_length: 100,
    type_attribute: FieldAllowedAttributeTypes.MULTIPLE_SUGGESTIONS_SEARCH_SELECT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_RESEARCHER_ORGANIZATION_WHICH_REPRESENTED_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_RESEARCHER_ORGANIZATION_WHICH_REPRESENTED_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.RESEARCHER,
  },
  {
    name: 'diseases',
    value_class_front: FieldAllowedValueClasses.DISEASES_SELECT,
    min_length: 1,
    max_length: 2000,
    type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_RESEARCHER_DISEASES_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_RESEARCHER_DISEASES_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.RESEARCHER,
  },
  {
    name: 'specialty',
    value_class_front: FieldAllowedValueClasses.SPECIALTIES_SELECT,
    min_length: 1,
    max_length: 2000,
    type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_PROFILE_RESEARCHER_SPECIALTIES_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_PROFILE_RESEARCHER_SPECIALTIES_PLACEHOLDER',
    security: false,
    scheme_name: ProfileFormTypes.RESEARCHER,
  },
];
